import React from 'react';
import { Box } from '@mui/material';

/**
 * GoogleMapEmbed - A simple component to embed Google Maps
 * @param {string} location - The location string to display on the map
 * @param {number} height - Height of the map in pixels (default: 300)
 * @param {string} width - Width of the map (default: '100%')
 */
function GoogleMapEmbed({ location, height = 300, width = '100%' }) {
  if (!location || !location.trim()) {
    return null;
  }

  // Encode the location for the URL
  const encodedLocation = encodeURIComponent(location);
  // Use Google Maps search URL format that ensures a visible red marker pin
  // The 'q' parameter searches for the location and Google Maps automatically adds a red marker
  // Adding '&t=m' ensures map view (not satellite) for better marker visibility
  // Zoom level 15 provides a good street-level view where the marker is clearly visible
  const mapUrl = `https://www.google.com/maps?q=${encodedLocation}&output=embed&z=15&t=m`;

  return (
    <Box
      sx={{
        width: width,
        height: height,
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        mt: 2,
      }}
    >
      <iframe
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={mapUrl}
        title={`Map showing ${location}`}
      />
    </Box>
  );
}

export default GoogleMapEmbed;

